export const RECEIPT = 'receipt';
